import { createAppointment } from "../http/HttpRequest";
import { getTotalPriceOfServiceWithPatients } from "../utils/pricesService";

import {
  BookingType,
  BookingTypeForBackend,
  CustomerType,
  OrganizationType,
  PatientType,
} from "./types";

const bookAppointment = async (
  data: BookingType,
  organization: OrganizationType
) => {
  const patients: PatientType[] = data.patients.map((patient) => {
    return {
      name: patient.name,
      surname: patient.surname,
      email: patient.email,
      documentType: patient.documentType,
      documentNumber: patient.documentNumber,
      addressType: patient.addressType,
      birthdate: patient.birthdate,
      commune: patient.commune,
      departmentNumber: patient.departmentNumber,
      phone: "56" + patient.phone,
      street: patient.street,
    };
  });

  // total booking price
  const amount: number = getTotalPriceOfServiceWithPatients(
    data.products.reduce(
      (acc, prod) => acc + prod.price,
      0
    ),
    patients.length,
    data.products.reduce(
      (acc, prod) => acc + prod.servicePrice,
      0
    ),
    organization,
    data.discount
  )[2];

  const booking: BookingTypeForBackend = {
    date: data.date,
    organizationId: organization.id,
    productsId: data.products.map((prod) => prod.id),
    servicesId: data.products.map((prod) => prod.serviceId),
    blockService: data.time.id,
    locationId: data.location.id,
    totalPrice: amount,
  };

  const customer: CustomerType = {
    firstName: data.customer.firstName,
    lastName: data.customer.lastName,
    documentNumber: data.customer.documentNumber,
    documentType: "RUT",
    email: data.customer.email,
    address: data.customer.address,
    phone: data.customer.phone,
  };

  try {
    const response = await createAppointment(booking, customer, patients);

    if (response.status === 200 && !!response.data.appointmentId)
      return response.data.appointmentId;
  } catch (e) {
    return undefined;
  }
};

export { bookAppointment };
